import { downloadedPdfUsersApi } from '../api/downloaded-pdf-users';
import { actionWrapper } from './actionWrapper';

export const SET_DOWNLOADED_PDF_USERS = 'SET_DOWNLOADED_PDF_USERS';

export const getDownloadedPdfUsers = () => actionWrapper(async () => {
  const downloadedPdfUsersData = await downloadedPdfUsersApi.getDownloadedPdfUsers();

  return {
    type: SET_DOWNLOADED_PDF_USERS,
    payload: downloadedPdfUsersData,
  };
});
